<template>
  <div class="licence-page">
    <RiClothesCard style="margin-top: 8px;" v-if="licenceObject.name">
      <RiClothesText textSize="1.8rem" v-if="!isEnglish">{{ `${licenceObject.name}のライセンス` }}</RiClothesText>
      <RiClothesText textSize="1.8rem" v-if="isEnglish">{{ `${licenceObject.name} Licence` }}</RiClothesText>
    </RiClothesCard>
    <RiClothesCard style="margin-top: 8px;">
      <RiClothesButton buttonType="outline" color="blue" text="日本語版(Japanese version)" :router_to="japaneseVersionURL"></RiClothesButton>
      <RiClothesButton buttonType="outline" color="blue" text="English version(英語版)" :router_to="englishVersionURL"></RiClothesButton>
    </RiClothesCard>
    <RiClothesCard style="margin-top: 8px; margin-bottom: 16px;">
      <RiClothesLicenceViewer :remarks="remarks" :isEnglish="isEnglish" isFullMode="true"></RiClothesLicenceViewer>
    </RiClothesCard>
  </div>
</template>

<script>
import RiClothesCard from "../components/RiClothesCard";
import RiClothesText from "../components/RiClothesText";
import RiClothesButton from "../components/RiClothesButton";
import RiClothesLicenceViewer from "../components/RiClothesLicenceViewer";

export default {
  components: {
    RiClothesCard,
    RiClothesText,
    RiClothesButton,
    RiClothesLicenceViewer
  },
  data() {
    return {
      licenceObject: {}
    }
  },
  computed: {
    isEnglish() {
      const lang = this.$route.query.lang;
      if(lang == "en" || lang == "english") {
        return true;
      } else {
        return false;
      }
    },
    remarks() {
      let result = null;
      if(this.licenceObject.licence != undefined || this.licenceObject.licence != null) {
        if(this.licenceObject.licence.remarks != undefined || this.licenceObject.licence.remarks != null) {
          result = this.licenceObject.licence.remarks;
        }
      }

      return result;
    },
    japaneseVersionURL() {
      const paramsId = this.$route.params.id;
      if(paramsId == undefined) {
        return "/licence";
      } else {
        return `/licence/${paramsId}`;
      }
    },
    englishVersionURL() {
      const paramsId = this.$route.params.id;
      if(paramsId == undefined) {
        return "/licence?lang=en";
      } else {
        return `/licence/${paramsId}?lang=en`;
      }
    }
  },
  mounted() {
    const paramsId = this.$route.params.id;
    if(paramsId == undefined) {
      return;
    }

    fetch(`/products/${paramsId}/licence.json`, { method: "GET" }).then(response => response.text()).then(text => {
      this.licenceObject = JSON.parse(text);
      document.title = `${this.licenceObject.name}のライセンス - RiClothes Website`;
    }).catch(error => {
      console.log(`Error: ${error}`);
    });
  }
}
</script>

<style lang="scss" scoped>

</style>